import React, { useEffect, useRef, useState } from 'react';
import * as THREE from 'three';

const HeroGlobe = () => {
    const vantaRef = useRef(null);
    const [vantaEffect, setVantaEffect] = useState(null);

    useEffect(() => {
        const isMobile = window.innerWidth <= 768;

        if (!vantaEffect && window.VANTA) {
            setVantaEffect(
                window.VANTA.GLOBE({
                    el: vantaRef.current,
                    THREE: THREE,
                    mouseControls: !isMobile, // Disable mouse on mobile
                    touchControls: isMobile,
                    gyroControls: false,
                    minHeight: 100.00,
                    minWidth: 100.00,
                    scale: isMobile ? 1.5 : 1.00, // Bigger on mobile
                    scaleMobile: 1.50,

                    backgroundColor: 0xffffff, // White background
                    color: 0xffffff, // Nova cyan/green
                    color2: 0x006EFD, // Innovator purple

                    // ✅ Lighter settings on mobile, reduced size to clear the nav bar
                    size: isMobile ? 0.9 : 0.60,
                    points: isMobile ? 5 : 10,
                    maxDistance: isMobile ? 13 : 16,
                    spacing: isMobile ? 20 : 15,
                    showDots: true,
                    backgroundAlpha: 0
                })
            );
        }

        return () => {
            if (vantaEffect) vantaEffect.destroy();
        };
    }, [vantaEffect]);

    return (
        <div
            ref={vantaRef}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 0,
                pointerEvents: 'none'
            }}
        />
    );
};

export default HeroGlobe;